import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "@/views/NotFound.vue";
import StatPanel from "@/views/StatPanel.vue";
import NaXem3ENW3W5x8H7Navst8 from "@/views/NaXem3ENW3W5x8H7Navst8.vue";
import HeER2s8fwck4gvoTgjHwe2 from "@/views/HeER2s8fwck4gvoTgjHwe2.vue";
import JLiT38iAmBqimmzpHZQSXe from "@/views/JLiT38iAmBqimmzpHZQSXe.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   name: 'datadog-context',
  //   component: DatadogController
  // },
  {
    path: "/NaXem3ENW3W5x8H7Navst8",
    name: "PolarChart",
    component: NaXem3ENW3W5x8H7Navst8,
  },
  {
    path: "/HeER2s8fwck4gvoTgjHwe2",
    name: "RadarChart",
    component: HeER2s8fwck4gvoTgjHwe2,
  },
  {
    path: "/JLiT38iAmBqimmzpHZQSXe",
    name: "Gauge",
    component: JLiT38iAmBqimmzpHZQSXe,
  },
  {
    path: "/stat-panel",
    name: "StatPanel",
    component: StatPanel,
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
